<template>
    <div id="app">
        <div class="box">
            <div class="bg">
                <img src="@/assets/bg.png" alt="">
            </div>
            <div class="box_son">
                <div class="biaoti">
                    <div class="biaoti_img">
                        <img src="@/assets/下载.png" alt="" class="img">
                    </div>
                </div>
                <p class="text">后台管理系统</p>
                <el-form ref="form" label-width="80px" class="from">
                    <el-form-item label="用户名">
                        <el-input type="text" v-model="username"></el-input>
                    </el-form-item>

                    <el-form-item label="密码">
                        <el-input type="password" v-model="password"></el-input>
                    </el-form-item>

                    <el-form-item class="btns">
                        <el-button type="primary" @click="login">登录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import {LoginApi} from '@/api/index.js';
export default {
    data() {
        return {
            username:"",
            password:"",
        }
    },
    methods:{
        async login(){
            const {data:res} = await LoginApi({
				username:this.username,
				password:this.password
			});
            if(res.code == 200){
                this.$message.success('登录成功');
                this.$router.push(`/main`)
            }else{
                this.$message.error('用户名或密码错误');
            }
        }
    }
}
</script>

<style scoped lang="less">
.box {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #93DEFE;
}

.box_son {
    width: 400px;
    border: 1px solid white;
    border-radius: 10px;
    background: white;
    position: relative;
}
.from {
    padding-right: 50px;
}
.biaoti{
    height: 100px;
}
.biaoti_img{
    width: 120px;
    height: 120px;
    background-color: white;
    display: flex;
    justify-content: center;
    border-radius: 50%;
    position: relative;
    bottom: 40px;
    left: 34%;
    overflow: hidden;
    border: 7px solid #93DEFE;
}
.img{
    width: 65px;
    height: 65px;
}
.text{
    text-align: center;
    letter-spacing:7px;
    font-size: 20px;
    color: #1379FB;
    font-weight: bold;
}
</style> 